import type { ContextMenuElementType, ObjectTreeNode } from '@core/core/types'

export function filterDraftOptions(
  menuItems: ContextMenuElementType[],
  objectTreeNode?: ObjectTreeNode,
) {
  if (objectTreeNode?.state == null) return menuItems

  const isPublicObjectTreeNode = objectTreeNode.state === 'Public'

  return menuItems.filter(({ type }) => {
    const isMovingToBin = type === 'ToBin'
    const isPublishing = type === 'Publish'

    return !(isPublicObjectTreeNode && (isMovingToBin || isPublishing))
  })
}
